import { render, staticRenderFns } from "./PrivacyTurnOn.vue?vue&type=template&id=7d6603ba&scoped=true"
import script from "./PrivacyTurnOn.vue?vue&type=script&lang=js"
export * from "./PrivacyTurnOn.vue?vue&type=script&lang=js"
import style0 from "./PrivacyTurnOn.vue?vue&type=style&index=0&id=7d6603ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6603ba",
  null
  
)

export default component.exports